module.exports = __webpack_public_path__ + "img/legalServices-9.b37e1fa1.png";